import '@justgiving/totaliser/src/Totaliser.scss';
import '@justgiving/totaliser/src/themes/PixelHeart/PixelHeart.scss';

import React, { FunctionComponent } from 'react';

import { Experiment, Variation } from '@justgiving/experiments';
import { Totaliser } from '@justgiving/totaliser';
import gql from 'graphql-tag';

import { TotaliserWrapperFragment } from '../../../types/__generated__';
import { Experiments } from '../../constants/experiments';
import usePageQuery, { buildQuery } from '../../hooks/usePageQuery';
import { useShouldSkipFirstToDonateEnrolment } from '../../hooks/useShouldSkipFirstToDonateEnrolment';
import TotaliserWrapperSkeleton from '../TotaliserWrapperSkeleton/TotaliserWrapperSkeleton';
import { SadFaceIcon } from './SadFaceIcon';

import './TotaliserWrapper.scss';

const FRAGMENT = buildQuery(gql`
  fragment TotaliserWrapper on Page {
    targetWithCurrency {
      value
    }
    donationSummary {
      totalAmount {
        value
      }
    }
  }
`);

const TotaliserWrapper: FunctionComponent = () => {
  const { loading, error, refetch, data = null } = usePageQuery<
    TotaliserWrapperFragment
  >(FRAGMENT, {
    notifyOnNetworkStatusChange: true,
  });

  // B2C_029 - First to donate
  // Can be removed when experiment has ended
  const shouldSkipFirstToDonateEnrolment = useShouldSkipFirstToDonateEnrolment();

  if (loading) {
    return <TotaliserWrapperSkeleton animated displayRefreshButton={false} />;
  }

  if (error) {
    return <TotaliserWrapperSkeleton onRefresh={refetch} />;
  }

  if (!data) {
    return null;
  }

  const target = data.targetWithCurrency?.value;

  if (!target) {
    return null;
  }

  const totalAmount = data.donationSummary?.totalAmount?.value ?? 0;
  const percentageOfTarget = (totalAmount / target) * 100;

  // B2C_029 - First to donate
  // Can be removed when experiment has ended
  return (
    <Experiment
      slug={Experiments.b2c_029_first_to_donate}
      skipEnrolment={shouldSkipFirstToDonateEnrolment}
    >
      <Variation name="A">
        <Totaliser
          className="jg-pages-totaliser-main"
          percent={percentageOfTarget}
          size="auto"
          isAnimated
        />
      </Variation>
      <Variation name="B">
        {totalAmount === 0 ? (
          <SadFaceIcon />
        ) : (
          <Totaliser
            className="jg-pages-totaliser-main"
            percent={percentageOfTarget}
            size="auto"
            isAnimated
          />
        )}
      </Variation>
      <Variation name="C">
        <Totaliser
          className="jg-pages-totaliser-main"
          percent={percentageOfTarget}
          size="auto"
          isAnimated
        />
      </Variation>
    </Experiment>
  );
};

export default TotaliserWrapper;
